export default "__VITE_ASSET__BLHArNmo__"